import Marquee from "react-fast-marquee";

const WORDS = [
  "You Can't Give Birth to Adults",
  "Know Your Stage",
  "Seven Days. One Roadmap.",
  "What Matters Next",
];

export const Ribbon = ({ dark = false }) => (
  <section
    aria-hidden="true"
    className={`relative overflow-hidden py-6 sm:py-9 ${dark ? "bg-ocean" : "bg-sand"} border-y border-[var(--line)]`}
    data-testid="marquee-ribbon"
  >
    <Marquee speed={55} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-serif italic text-3xl sm:text-5xl lg:text-6xl tracking-tight px-8 ${
              dark ? "text-cream" : "text-ocean"
            }`}
          >
            {w}
          </span>
          <span className={`text-2xl ${dark ? "text-cognac" : "text-cognac"}`}>✳</span>
        </span>
      ))}
    </Marquee>
  </section>
);
